/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Button from 'react-bootstrap/Button';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import EditorContainer from '../../../../SharedModules/AdvanceTextEditor';
import LetterTemplateTableGrid from './gridComponents/LtTableGrid';
import { letterTemplateHead } from './gridComponents/LtTableHead';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import LTCommonModal from './gridComponents/LTCommonModal';
import {
  getRandomNumberByInput,
  convertBlockmaptoHTML,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  freeFromText,
  pastDueInvoiceData,
  windowAddressIndicatorError,
  maintainLetterTemplate,
} from './gridComponents/ConstantData';
import {
  MERGE_FIELD_ITEM_REQUIRED,
  ONLY_ONE_FREE_FROM_TEXT,
  NOT_ANY_SELECTED_MERGE_FIELD,
  ENTER_VALID_QUARTER,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  updateAllSubMergeField,
  saveLetterTemplateDetailList,
  saveLTDMergeFieldList,
} from '../store/actions';

function LTBodyTab(props) {
  const {
    isEnableSave,
    isSaveOpen,
    isEnableCancel,
    isCancelOpen,
    mainFilterValue,
    setStateChange,
    setErrorStateChange,
    isEnablebyRole,
  } = props;
  const gridRef = React.useRef();
  const dispatch = useDispatch();

  const letterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateDetail
  );
  const letterTemplateDetailPage = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail.searchValue
  );
  const deletedMF = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.deleteMF
  );
  const MFList = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail
        .templateDetails
  );
  const allSelectedMergeField = useSelector(
    (state) => state?.sharedState?.LetterTemplateReducer?.allSelectedMergeField
  );
  const allMergeFieldListForDefaultFooter = useSelector(
    (state) =>
      state?.sharedState?.LetterTemplateReducer
        ?.allMergeFieldListForDefaultFooter
  );
  const detailTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailTab
  );

  const setFilterValueAction = (value) =>
    dispatch(saveLetterTemplateDetailList(value));

  const [loading, setLoading] = React.useState(true);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [viewMergeFieldList, setViewMergeFieldList] = React.useState(false);
  const [selectedMergeField, setSelectedMergeField] = React.useState([]);
  const [selectedSubMergeField, setSelectedSubMergeField] = React.useState([]);
  const [addInput, setAddInput] = React.useState([]);
  const [deleteInput, setDeleteInput] = React.useState([]);
  const [deleteList, setDeleteList] = React.useState([]);
  const [pageView, setPageView] = React.useState(null);
  const [isError, setIsError] = React.useState(false);
  const [errorModalTitle, setErrorModalTitle] = React.useState('Warning');
  const [state, setState] = React.useState({
    startQtr: 'O',
    startQtrCd: '',
    endQtr: 'O',
    endQtrCd: '',
  });
  const [isErrorMsg, setIsErrorMsg] = React.useState(null);
  //  No need show Table because This Table not mentioned UI/document
  const [hideTableGrid, setHideTableGrid] = React.useState(true);
  const [filterValue, setSetFilterValue] = React.useState({
    body: null,
  });
  const [htmlText, setHtmlText] = React.useState([]);
  const [editBodyMergeField, setEditBodyMergeField] = React.useState([]);
  const letterTemplateDetailRef = React.useRef(letterTemplateDetail);
  letterTemplateDetailRef.current = letterTemplateDetail;
  const allSelectedMergeFieldRef = React.useRef(allSelectedMergeField);
  allSelectedMergeFieldRef.current = allSelectedMergeField;

  const onChangeMergeFieldRedux = (data) => {
    setFilterValueAction({
      ...letterTemplateDetail,
      ...data,
    });
  };

  // This just get new update data from redux to useState
  React.useEffect(() => {
    setLoading(false);
    if (
      letterTemplateDetailPage &&
      !_.isEmpty(letterTemplateDetailPage) &&
      letterTemplateDetailPage.body
    ) {
      setSetFilterValue({ body: letterTemplateDetailPage.body });
    }
  }, [letterTemplateDetailPage.body]);

  React.useEffect(() => {
    let newList = [];
    if (!_.isEmpty(deletedMF)) {
      newList = [...deletedMF];
      if (!_.isEmpty(htmlText)) {
        if (JSON.stringify(deleteList) !== JSON.stringify(newList)) {
          const bodyData = [];
          const list = _.filter(newList, (val) => {
            if (_.includes(htmlText, val.displayName)) {
              bodyData.push(val);
            } else {
              return val;
            }
          });
          setDeleteList(list);
          setStateChange({ deleteMF: list });
          setDeleteInput(bodyData);
        }
      }
    }
  }, [deletedMF, htmlText]);

  React.useEffect(() => {
    const hasBodyEditor = !!filterValue?.body;
    const shouldUseFallback = _.isEmpty(htmlText) && !_.isEmpty(letterTemplateDetail?.templateDetails) && !hasBodyEditor;

    if (!_.isEmpty(htmlText) || shouldUseFallback) {
      const data = [];
      if (
        letterTemplateDetail &&
        !_.isEmpty(letterTemplateDetail?.templateDetails)
    ) {
      const sourceItems = !_.isEmpty(htmlText)
        ? htmlText
        : _.map(
            _.filter(letterTemplateDetail.templateDetails, (l) => !l.tempDetRemoved),
            'displayName'
          );

      if (sourceItems.length > 0) {
        sourceItems.forEach((item) => {
          const res = item.replace(/[0-9]/g, '');
          _.filter(letterTemplateDetail?.templateDetails, (i) => {
            if (
              item === i?.displayName 
            ) {
              const otherData = !_.isEmpty(allMergeFieldListForDefaultFooter)
                ? _.filter(
                    allMergeFieldListForDefaultFooter,
                    (l) => l.description === res
                  )
                : [];
              if (!_.isEmpty(otherData)) {
                i.description = otherData[0].description;
                i.templateMetaDataSeqNum = otherData[0].templateMetaDataSeqNum;
                i.displayOrder = otherData[0].displayOrder;
                i.tempDatailItems = !_.isEmpty(i.tempDatailItems)
                  ? _.map(i.tempDatailItems, (v) => ({
                      ...v,
                      isSelected: true,
                    }))
                  : [];
                data.push(i);
              }
            }
            return i;
          });
        });
        let data1 = _.uniqBy(data, 'displayName');
        data1 = _.filter(data1, ['tempDetRemoved', false]);
        const prev = allSelectedMergeFieldRef.current || {};
        if (_.isEmpty(data1) && !_.isEmpty(prev.body)) {
          return;
        }
        if (_.isEqual(prev.body, data1)) {
          return;
        }
        dispatch(
          saveLTDMergeFieldList({
            ...prev,
            body: data1,
          })
        );
      }
    }
  }
  }, [
    htmlText,
    letterTemplateDetail,
    allMergeFieldListForDefaultFooter,
    filterValue.body,
  ]);

  React.useEffect(() => {
    if (!filterValue?.body) return;
    const detail = letterTemplateDetailRef.current;
    if (!detail?.templateDetails?.length) return;

    const htmlData = convertBlockmaptoHTML(filterValue.body);
    const paramsPattern = /[^{}]+(?=})/g;
    const extractParams = htmlData.match(paramsPattern);
    const tokenSet = new Set(extractParams || []);

    const mfd = _.cloneDeep(detail.templateDetails);
    let changed = false;
    mfd.forEach((l) => {
      if (l.page !== 'body') return;

      const stillInEditor = tokenSet.has(l.displayName);
      if (!stillInEditor && !l.tempDetRemoved) {
        l.tempDetRemoved = true;
        if (!_.isEmpty(l.tempDatailItems)) {
          l.tempDatailItems.forEach((li) => {
            li.tempdItemRemoved = true;
          });
        }
        changed = true;
      }
    });
    if (changed) {
      setFilterValueAction({
        ...detail,
        templateDetails: mfd,
      });
    }
  }, [filterValue.body]);

  const removeSuccessMsg = () => {
    let errorMsg = detailTabErrorMessages;
    if (!_.isEmpty(errorMsg)) {
      errorMsg = _.filter(errorMsg, (l) => l.id !== 'sucessMsg');
    }
    setErrorStateChange({ detailPage: _.uniqBy(errorMsg, 'id') });
  };

  const filterAction = (flType, value) => {
    dispatch(
      saveLetterTemplateDetailList({
        ...letterTemplateDetail,
        searchValue: {
          ...letterTemplateDetailPage,
          [flType]: value,
        },
      })
    );
    removeSuccessMsg();
    setStateChange({ edit: true });
  };

  const addMergeFieldAction = () => {
    setLoading(true);
    setPageView('allMergeField');
    setViewMergeFieldList(true);
    dispatch(updateAllSubMergeField([]));
    // dispatch(getAllMergeFieldList({ templateTypeCd: ['ALL', 'COVER'] }));
  };

  const editMergeFieldAction = () => {
    let openError = true;
    let dataList = allSelectedMergeField?.body;
    if (_.isEmpty(dataList)) {
      const notRemoved = _.filter(MFList || [], (l) => !l.tempDetRemoved);
      if (!_.isEmpty(htmlText)) {
        dataList = _.filter(notRemoved, (l) =>
          _.includes(htmlText, l.displayName)
        );
      }
      if (_.isEmpty(dataList)) {
        dataList = _.filter(notRemoved, (l) => l.page === 'body');
      }
    }
    if (!_.isEmpty(dataList)) {
      setEditBodyMergeField(dataList);
      setPageView('updateMergeField');
      dispatch(updateAllSubMergeField([]));
      setViewMergeFieldList(true);
      openError = false;
    }
    if (openError && !isEnableSave) {
      setIsError(true);
      setIsErrorMsg(NOT_ANY_SELECTED_MERGE_FIELD);
    }
  };

  const onSelectMergeRow = (e) => {
    if (!_.isEmpty(e.mergeField)) {
      const mfd = _.uniqBy([...e.mergeField], 'templateMetaDataSeqNum');
      setSelectedMergeField(mfd);
    }
  };

  const onSelectSubMergeRow = (e) => {
    let selectedRow = e.selectedRows;
    if (!_.isEmpty(e.selectedRows)) {
      selectedRow = _.filter(selectedRow, (l) => l.isSelected);
    }
    setSelectedSubMergeField(selectedRow);
  };

  const onClickOkMergeField = () => {
    const mfd = !_.isEmpty(MFList) ? [...MFList] : [];
    const checkMFD = _.filter(mfd, (l) => {
      const res = l.displayName.replace(/[0-9]/g, '');
      return res === freeFromText && !l.tempDetRemoved;
    });
    const checkPDIN = _.filter(
      selectedMergeField,
      (l) => l.description === pastDueInvoiceData
    );
    const checkContactAddress = _.filter(
      selectedMergeField,
      (l) => l.description === 'Contact Address'
    );
    if (
      !_.isEmpty(checkContactAddress) &&
      letterTemplateDetailPage?.windowAddrInd === 1
    ) {
      setIsError(true);
      setIsErrorMsg(windowAddressIndicatorError);
      setErrorModalTitle(maintainLetterTemplate);
      return;
    }
    let passFreeFromText = false;
    let passPastDueInvoiceData = false;
    if (!_.isEmpty(checkMFD)) {
      const getSelected = _.filter(selectedMergeField, (l) => {
        const res1 = checkMFD[0].displayName.replace(/[0-9]/g, '');
        return l.description === res1;
      });
      passFreeFromText = !_.isEmpty(getSelected);
    }
    if (!_.isEmpty(checkPDIN)) {
      const newData = checkPDIN[0];
      if (!newData.startQtrCd || !newData.endQtrCd) {
        passPastDueInvoiceData = true;
      }
    }
    if (!passFreeFromText && !passPastDueInvoiceData) {
      if (!_.isEmpty(selectedSubMergeField)) {
        selectedSubMergeField.forEach((item) => {
          item.tempdItemRemoved = false;
          return item;
        });
        const newMfd = _.map(selectedMergeField, (item) => {
          const ranNum = getRandomNumberByInput(1)[0];
          const list = _.isEmpty(mfd)
            ? []
            : _.filter(mfd, (l) => {
                if (l.displayName && l.displayName !== '') {
                  const res = l.displayName.replace(/[0-9]/g, '');
                  return res === item.description;
                }
              });
          const num = list.length + 1;
          item.key = ranNum;
          item.templateDetailSeqNum = null;
          item.displayName = `${item.description}${num}`;
          item.page = 'body';
          item.tempDetRemoved = false;
          item.tempDatailItems = !_.isEmpty(selectedSubMergeField)
            ? [...selectedSubMergeField]
            : [];
          mfd.push(item);
          return item;
        });
        setAddInput(newMfd);
        setSelectedMergeField([]);
        setSelectedSubMergeField([]);
        onChangeMergeFieldRedux({
          templateDetails: mfd,
        });
        setViewMergeFieldList(false);
        setIsError(false);
        setIsErrorMsg(null);
        setEditBodyMergeField([]);
      } else {
        setIsError(true);
        setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
      }
    } else {
      if (!_.isEmpty(checkPDIN)) {
        if (state.startQtr !== 'D') {
          setIsError(true);
          setIsErrorMsg(ENTER_VALID_QUARTER);
        }
      }
      if (!_.isEmpty(checkMFD)) {
        setIsError(true);
        setIsErrorMsg(ONLY_ONE_FREE_FROM_TEXT);
      }
    }
  };

  const onClickOkEditMergeField = () => {
    if (!_.isEmpty(selectedSubMergeField)) {
      const newSelSubMF = _.filter(selectedSubMergeField, (l) => l.isSelected);
      const mfd = !_.isEmpty(MFList) ? _.cloneDeep(MFList) : [];
      if (!_.isEmpty(newSelSubMF) && !_.isEmpty(mfd)) {
        const checkPDIN = _.filter(selectedMergeField, (l) => {
          const res = l.displayName.replace(/[0-9]/g, '');
          return res === pastDueInvoiceData;
        });
        let passPastDueInvoiceData = false;
        if (!_.isEmpty(checkPDIN)) {
          const newData = checkPDIN[0];
          if (!newData.startQtrCd || !newData.endQtrCd) {
            passPastDueInvoiceData = true;
          }
        }
        if (!passPastDueInvoiceData) {
          mfd.forEach((item) => {
            const changeList = _.filter(
              selectedMergeField,
              (l) =>
                l.templateMetaDataSeqNum === item.templateMetaDataSeqNum &&
                l.templateDetailSeqNum === item.templateDetailSeqNum
            );
            if (!_.isEmpty(changeList)) {
              if (
                changeList[0].templateMetaDataSeqNum ===
                item.templateMetaDataSeqNum
              ) {
                const { tempDatailItems, ...rest } = item;
                Object.keys(rest).map((k) => {
                  item[k] = changeList[0][k];
                });
                const newData = [];
                const tempDatailItems1 = _.filter(
                  item.tempDatailItems,
                  (it) =>
                    it.templateDetailItemSeqNum &&
                    it.templateDetailItemSeqNum !== '' &&
                    it.templateDetailSeqNum &&
                    it.templateDetailSeqNum !== ''
                );
                _.map(_.cloneDeep(tempDatailItems1), (it) => {
                  const selSMF = _.filter(
                    selectedSubMergeField,
                    (val) => it.columnHeading === val.columnHeading
                  );
                  if (_.isEmpty(selSMF)) {
                    it.tempdItemRemoved = true;
                    it.isSelected = false;
                  } else {
                    Object.keys(selSMF[0]).map((k) => {
                      it[k] = selSMF[0][k];
                    });
                    it.tempdItemRemoved = false;
                    it.isSelected = true;
                  }
                  newData.push(it);
                  return it;
                });
                selectedSubMergeField.forEach((val) => {
                  const selSMF1 = _.filter(
                    tempDatailItems,
                    (l) => l.columnHeading === val.columnHeading
                  );
                  if (_.isEmpty(selSMF1)) {
                    val.tempdItemRemoved = false;
                    newData.push(val);
                    // item.tempDatailItems.push(val);
                  }
                });
                item.tempDatailItems = _.filter(newData, (l) => l.columnName);
              }
            }
            return item;
          });
          setSelectedSubMergeField([]);
          onChangeMergeFieldRedux({
            templateDetails: mfd,
          });
          setViewMergeFieldList(false);
          setIsError(false);
          setIsErrorMsg(null);
          setStateChange({ edit: true });
          setEditBodyMergeField([]);
        } else {
          if (state.startQtr !== 'D') {
            setIsError(true);
            setIsErrorMsg(ENTER_VALID_QUARTER);
          }
        }
      } else {
        setIsError(true);
        setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
      }
    } else {
      setIsError(true);
      setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
    }
  };

  const onDeleteMergeOkAction = (row) => {
    if (!_.isEmpty(MFList)) {
      let mfd = _.cloneDeep(MFList);
      mfd = _.map(mfd, (l) => {
        if (
          l.key === row.key &&
          l.templateMetaDataSeqNum === row.templateMetaDataSeqNum &&
          l.displayName === row.displayName
        ) {
          l.tempDetRemoved = true;
          if (!_.isEmpty(l.tempDatailItems)) {
            l.tempDatailItems.forEach((li) => {
              li.tempdItemRemoved = true;
            });
          }
        }
        return l;
      });
      if (!row.templateDetailSeqNum) {
        const getAllList = _.filter(
          mfd,
          (al) => al.description === row.description && !al.templateDetailSeqNum
        );
        const getAllListMap = _.map(getAllList, (ml) => {
          const res = ml.displayName.replace(/[a-zA-Z- ]/g, '');
          return {
            displayName: ml.displayName,
            posNum: _.trim(res),
          };
        });
        const getLetestList = _.maxBy(getAllListMap, 'posNum');
        if (!_.isEmpty(getLetestList)) {
          if (getLetestList.displayName === row.displayName) {
            mfd = _.filter(mfd, (l) => l.key !== row.key);
          }
        }
      }
      onChangeMergeFieldRedux({
        templateDetails: mfd,
      });
      let mfg = _.filter([...MFList], (l) => l.displayName === row.displayName);
      mfg = _.concat([...deletedMF], [...mfg]);
      setStateChange({ deleteMF: mfg });
    }
  };

  const getTextFromHtml = React.useCallback((htmlTextData) => {
    setHtmlText(htmlTextData || []);
  }, []);

  return (
    <div
      className='lettterTemplate p-0'
      data-testid='letter-template-body-tab-component'
    >
      <Spinner load={loading} />
      <div className='tabs-container pl-0 pr-0'>
        <div className='no-margin'>
          {hideTableGrid ? (
            ''
          ) : (
            <div className='TemplateList'>
              <LetterTemplateTableGrid
                gridRef={gridRef}
                data-testid='deleteMerge'
                cellHead={letterTemplateHead}
                dataList={
                  MFList
                    ? _.orderBy(
                        _.filter([...MFList], (l) => l && !l.tempDetRemoved),
                        ['displayName'],
                        ['asc']
                      )
                    : []
                }
                gridHeight={200}
                fileName='Letter Template'
                setTotalResultCount={setTotalResultCount}
                previewOkModalAction={onDeleteMergeOkAction}
              />
              {/* <p className="total-results" tabIndex="0">
                Total Results:
                <b>{totalResultCount}</b>
              </p> */}
            </div>
          )}
          <div className='btn-wrapper mb-2'>
            <div className='float-right mt-2 hide-on-print'>
              <Button
                className='btn btn-success'
                data-testid='merge-field'
                onClick={addMergeFieldAction}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName='Icon-outline-add-circle' /> Merge Field
              </Button>
              <Button
                className='btn btn-success'
                data-testid='cancelBtn'
                onClick={editMergeFieldAction}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName='Icon-outline-edit' />
                Merge Field
              </Button>
            </div>
            <div className='clearfix' />
          </div>

          <div className='TemplateInput'>
            <EditorContainer
              data-testid='editorContainer'
              height='400px'
              insertData={addInput}
              deleteData={deleteInput}
              result={filterValue.body}
              getTextFromHtml={getTextFromHtml}
              editorStateChange={(e) => setStateChange({ edit: true })}
              filterAction={(e) => {
                filterAction('body', e);
              }}
              isEnablebyRole={isEnablebyRole}
            />
          </div>
        </div>

        {viewMergeFieldList && (
          <CommonModal
            className='frr-dialog-css'
            open={viewMergeFieldList}
            viewAction
            viewHeader
            onOk={
              pageView === 'updateMergeField'
                ? onClickOkEditMergeField
                : onClickOkMergeField
            }
            okTitle='Update'
            onClose={() => {
              setEditBodyMergeField([]);
              setViewMergeFieldList(false);
            }}
            closeTitle='Cancel'
            modalTitle={`${
              pageView === 'updateMergeField' ? 'Update' : 'Select'
            } a Merge Field`}
            childrenComponent={
              <LTCommonModal
                closeModal={setViewMergeFieldList}
                setLoading={setLoading}
                pageView={pageView}
                editBodyMergeField={editBodyMergeField}
                selectedMergeField={selectedMergeField}
                onSelectMergeRow={onSelectMergeRow}
                onSelectSubMergeRow={onSelectSubMergeRow}
                selectedSubMergeField={selectedSubMergeField}
                setState={setState}
                mainFilterValue={mainFilterValue}
                setIsError={setIsError}
                setIsErrorMsg={setIsErrorMsg}
                hidePageNumberMergeField
              />
            }
          />
        )}

        {isError && (
          <CommonModal
            className='dialog-420'
            open={isError}
            viewAction
            viewHeader
            onClose={() => setIsError(false)}
            closeTitle='Ok'
            modalTitle={errorModalTitle}
            childrenComponent={<div className='p-3'>{isErrorMsg}</div>}
          />
        )}
      </div>
    </div>
  );
}

export default LTBodyTab;
